<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
                <template #cell(telephone)="data">
                  0{{ data.item.telephone }}
                </template>
              <template #cell(actions)="data">
                <b-button @click="edit(data.item.patient_id,data.item.name,data.item.visit_id)" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> Pick Samples </b-button>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="edit-item" centered :title=patient_name title-class="font-14" hide-footer>
        <form @submit.prevent="editItem">
            <div class="form-group mb-2">
            <input v-model="patient_id" type="hidden">
            <input v-model="visit_id" type="hidden">
            <table class="table table-sm mt-2" style="color: black;" density="compact">
            <thead><tr><th>Test</th><th>Sample</th></tr></thead>
              <tbody>
              <tr v-for="item in labtests" :key="item.id">
                <td>{{ item.service.name }}</td>
                <td><multiselect v-model="sample" :options="labsamples" label="name"></multiselect></td>
              </tr>
              </tbody>
            </table>
            <label>Picked From (where)</label>
            <input v-model="pickedfrom" type="text" placeholder="Place where sample was taken from" class="form-control" />
            <label>Picked By</label>
            <multiselect v-model="pickedby" :options="users" label="full_name"></multiselect>
            <label>Date Picked</label>
            <input v-model="datepicked" type="date" class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-item')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>
  </Layout>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { labPatientMethods, labPatientComputed, labsampleMethods, labsampleComputed,  userMethods, userComputed} from "@/state/helpers";

export default {
  page: {
    title: "Pick Test Samples",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader,Multiselect
  },
  data() {
    return {
      title: "Pick Test Samples",
      items: [ {text: "Dashboard",to: "/",}, {text: "Pick Test Samples",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'name', label: 'Name', visible: true },
          { key: 'gender', label: 'Gender', visible: true },
          { key: 'telephone', label: 'Telephone', visible: true },
          { key: 'address', label: 'Address', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      patient_id:'',
      patient_name:'',
      visit_id:'',
      datepicked:new Date().toLocaleDateString('fr-CA'),
      service_id:'',
      sample:'',
      pickedfrom:'',
      pickedby:'',
      labtests:[],
    };
  },
  computed: {
    ...labPatientComputed,
    ...labsampleComputed,
    ...userComputed,
    List() { return this.labpatients.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.labpatients.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.labpatients.length>0) { a=false;} else { a=true;} return a },
  },
  mounted() {
    this.fetchLabPatients();
    this.fetchUsers();
    this.fetchLabsamples();
    this.TotalRows = this.labpatients.length;
    this.isBusy=false;
  },
  methods: {
    ...labPatientMethods,
    ...labsampleMethods,
    ...userMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async edit(id,name,visit){
      this.patient_id=id;
      this.patient_name="Sample Pick Up for "+name;
      this.service_id=visit;
      let formData = new FormData();
      formData.append("patient_id", this.patient_id);
      formData.append("visit_id", this.service_id);
      let url = "/findpatientlabtests";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.labtests=response.data.labtests;
        this.$bvModal.show('edit-item')
      }
    })
    },
    async editItem(){ 
    let formData = new FormData();
    formData.append("patient", this.patient_id);
    formData.append("visit_id", this.visit_id);
    formData.append("service_id", this.service_id);
    formData.append("sample", this.sample.id);
    formData.append("pickedfrom", this.pickedfrom);
    formData.append("pickedby", this.pickedby.id);
    formData.append("datepicked", this.datepicked);
    let url = "/addsamplespicked";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchLabPatients();
        this.$bvModal.hide('edit-item');
        this.visit_id="";
        this.patient_name="";
        this.sample="";
        this.datepicked="";
      }
    });
    },
  },
};
</script>